export default {
  async loadDashboardConsignments() {
    try {
      let res = await axios.get('/carry-freight/legs?dashboard');

      if (!res.data.data) {
        return [];
      }
      
      return formatConsignments(res.data.data);
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  async fetchConsignments(page, fields) {
    // Fetch all carrier consignments if there are no params
    let res;
    if (!fields) {
      res = await axios.get(`/carry-freight/legs?page=${page}`);
    } else {
      let params = {
        'status': convertStatus(fields.status),
        'time_frame': convertTimeFrame(fields.timeFrame)
      }
      res = await axios.get(`/carry-freight/legs?page=${page}`, { params });
    }

    res.data.data = formatConsignments(res.data.data);
    return res.data;
  }
};

function formatConsignments(consignments) {
  consignments.forEach((consignment) => {
    if (consignment.status_human === 'Assigned') {
      consignment.status_human = 'Booked';
    } else if (consignment.status_human === 'Picked up') {
      consignment.status_human = 'In Transit';
    }
  });
  return consignments;
}

function convertStatus(status) {
  status = status.toLowerCase();
  if (status === 'booked') {
    return 5;
  }
  if (status === 'in transit') {
    return 20;
  }
  if (status === 'delivered') {
    return 40;
  }
  if (status === 'cancelled') {
    return 99;
  }
}

function convertTimeFrame(timeFrame) {
  timeFrame = timeFrame.toLowerCase();
  if (timeFrame === 'day') {
    return 1;
  } else if (timeFrame === 'week') {
    return 7;
  } else if (timeFrame === 'month') {
    return 30;
  } else if (timeFrame === 'year') {
    return 365;
  } else if (timeFrame === 'all') {
    return null;
  }
}
